var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0369 12.0697C7.37753 12.0697 8.68007 11.6223 9.73768 10.7983L13.7282 14.7895C14.0265 15.0775 14.5014 15.0693 14.7893 14.771C15.0703 14.4801 15.0703 14.0192 14.7893 13.7282L10.7988 9.73704C12.8432 7.10519 12.3671 3.31387 9.73563 1.26922C7.10419 -0.775438 3.31347 -0.298997 1.26913 2.33286C-0.775206 4.96472 -0.299132 8.75603 2.33231 10.8007C3.39169 11.6238 4.6954 12.0703 6.0369 12.0697ZM2.83065 2.82893C4.60136 1.05795 7.47245 1.05766 9.24345 2.82893C11.0141 4.59991 11.0144 7.47146 9.24345 9.24273C7.47274 11.0137 4.60165 11.014 2.83065 9.24273C1.05995 7.48435 1.0494 4.62335 2.80722 2.85237C2.81513 2.84446 2.82274 2.83684 2.83065 2.82893Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.83a79d7e.svg";
export { ForwardRef as ReactComponent };